import { getConfig } from '../../../registration/util/config';
import onbClient from '../../../registration/util/client';
import { handleServerErrors } from '../../../registration/util/error';

export function sendSms() {
    onbClient
        .post(`/post/onboarding-no-camera`)
        .then(closeRegistration())
        .catch(handleServerErrors());
    return db => db;
}

export const closeRegistration = () => {
    getConfig().gotoHomepage();
};

export const goToStep0 = () => {
    getConfig().goBackToStep0();
};
